<!-- 首页跳转 没有更多校友资源页面  -->
<!-- 捐赠成功页面点击查看更多校友跳转至该页面 -->
<template>
  <div class="alumniResourcesBox">
    <!-- 下拉菜单 -->
    <div class="filter-dropdown">
      <van-dropdown-menu active-color="#00706E">
        <van-dropdown-item title="常驻城市" ref="dropdownItemCity">
          <van-tree-select
            :items="cityList"
            :active-id.sync="activeCitys"
            :main-active-index.sync="activeProvinceIndex"
            @click-nav="checkProvince"
          />
          <div
            style="display: flex; padding: 5px 0; border-top: 1px solid #f3f3f3"
          >
            <van-button
              round
              block
              type="default"
              style="margin: 0 5px"
              @click="activeCitys = []"
              >重置</van-button
            >
            <van-button
              round
              block
              type="danger"
              style="margin: 0 5px"
              @click="checkConfirm"
              >确认</van-button
            >
          </div>
        </van-dropdown-item>

        <van-dropdown-item title="行业领域" ref="dropdownItemIndustry">
          <van-tree-select
            :items="industryList"
            :active-id.sync="activeIndustry"
            :main-active-index.sync="activeIndustryIndex"
            @click-nav="checkIndustry"
          />
          <div
            style="display: flex; padding: 5px 0; border-top: 1px solid #f3f3f3"
          >
            <van-button
              round
              block
              type="default"
              style="margin: 0 5px"
              @click="activeIndustry = []"
              >重置</van-button
            >
            <van-button
              round
              block
              type="danger"
              style="margin: 0 5px"
              @click="checkConfirm"
              >确认</van-button
            >
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>

    <!-- <div class="filter-box"> -->
    <!-- 搜索 -->
    <!-- <div class="search-box">
        <van-search v-model="searchData.name" shape="round" background="#FFFFFF" placeholder="请输入校友名称"
          @search="handleSearchName" />
      </div> -->
    <!-- </div> -->
    <!-- 占位 -->
    <!-- <div style="height: 102px"></div> -->
    <div class="resources-list-box">
      <template v-if="alumnusList.length > 0">
        <van-list
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <template v-for="item in alumnusList" class="alumni-card-box">
            <alumni-info-card :info="item" @go="goAlumniDetail" />
          </template>
        </van-list>
      </template>
      <div v-else>
        <van-empty description="没有发现校友" />
      </div>
    </div>
    <!--  <div style="padding-bottom: env(safe-area-inset-bottom);">
      <van-pagination v-model="searchData.currentPage" :total-items="total" force-ellipses :items-per-page="searchData.pageSize" @change="pageChange" />
    </div> -->
  </div>
</template>

<script>
import AlumniInfoCard from "./components/AlumniInfoCard";
export default {
  components: {
    AlumniInfoCard,
  },
  data() {
    return {
      searchData: {
        userId: window.localStorage.getItem("user_id"),
        // userId: "43995354",
        name: null,
        currentPage: 1,
        pageSize: 10,
        bigShot: 0,
      },
      total: 0,
      activeCitys: [], // 选中的城市列表
      activeProvinceIndex: 0, // 选中省的索引
      cityList: [],
      provinceList: [],
      activeIndustry: [], // 选中的行业列表
      activeIndustryIndex: 0, // 选中1级行业的索引
      industryIndexList: [],
      industryList: [],
      alumnusList: [], // 校友列表
      loading: false,
      finished: false,
      alumnusLastPage: "", // 最后一页
    };
  },
  created() {
    this.initData();
    this.getProvince();
    this.getIndustry1List();
  },
  methods: {
    async initData() {
      const res = await this.$http.get("/amresources/getAlumniInDetailList", {
        params: {
          city: this.activeCitys.toString(),
          hangye: this.activeIndustry.toString(),
          name: this.searchData.name,
          userId: this.searchData.userId,
          currentPage: this.searchData.currentPage,
          perPage: this.searchData.pageSize,
          bigShot: 0,
        },
      });
      //console.log(res)
      res.data.list.forEach((item) => {
        item.isOpen = false;
        return item;
      });
      // this.alumnusList.push(res.data.list)
      for (let i = 0; i < res.data.list.length; i++) {
        this.alumnusList.push(res.data.list[i]);
      }
      this.alumnusLastPage = res.data.lastPage;
      this.total = res.data.total;
      // for (let i = 0; i < res.data.list.length; i++) {
      //   this.alumnusList.push(res.data.list[i])
      // }
      // this.alumnusNum = res.data.total;
      // this.alumnusLastPage = res.data.lastPage;
    },
    handleSearchName(e) {
      this.searchData.name = e;
      this.alumnusList = [];
      this.initData();
    },
    async getProvince() {
      const res = await this.$http.get("/amresources/getProvinceList");
      // this.province = res.data.ProvinceList;
      if (res.data.ProvinceList) {
        const arr = [];
        this.provinceList = res.data.ProvinceList;
        res.data.ProvinceList.forEach((item, index) => {
          arr.push({
            text: item,
            children: "", //this.getCity(item)
          });
        });
        this.cityList = arr;
      }
      // 初始化第一条省份数据
      this.checkProvince(0);
    },
    /*  getCity(pname) {
       const arr = []
       this.$http.get("/amresources/getCityList", {
         params: { CityList: pname }
       }).then(res => {
         if (res.data.CityList) {
           res.data.CityList.forEach(item => {
             arr.push({
               text: item,
               id: item
             })
           })
         }
       }).catch(() => { })
       return arr
     }, */
    // 行业领域1级分类
    async getIndustry1List() {
      const res = await this.$http.get("/amresources/getIndustryLevelList");
      if (res.data.IndustryLevelList) {
        const arr = [];
        this.industryIndexList = res.data.IndustryLevelList;
        res.data.IndustryLevelList.forEach((item, index) => {
          arr.push({
            text: item,
            children: "", //this.getIndustry2List(item)
          });
        });
        this.industryList = arr;
      }
      this.checkIndustry(0);
    },
    // 行业领域2级分类
    /* getIndustry2List(industry) {
      const arr = []
      this.$http.get("/amresources/getIndustryList", {
        params: { industryLevel: industry }
      }).then(res => {
        if (res.data.IndustryList) {
          res.data.IndustryList.forEach(item => {
            arr.push({
              text: item,
              id: item
            })
          })
        }
      }).catch(() => { })
      return arr
    }, */
    checkProvince(e) {
      // if (!this.cityList[e].children || this.cityList[e].children === []) {
      //   this.$nextTick(() => {
      //     this.cityList[e].children = this.getCity(this.cityList[e].text)
      //   })
      // }

      this.$http
        .get("/amresources/getCityList", {
          params: { CityList: this.provinceList[e] },
        })
        .then((res) => {
          if (res.data.CityList) {
            this.cityList[e].children = [];
            res.data.CityList.forEach((item) => {
              this.cityList[e].children.push({
                text: item,
                id: item,
              });
            });
          }
        })
        .catch(() => {});
    },
    checkIndustry(e) {
      // if (!this.cityList[e].children || this.cityList[e].children === []) {
      //   this.$nextTick(() => {
      //     this.cityList[e].children = this.getCity(this.cityList[e].text)
      //   })
      // }
      this.$http
        .get("/amresources/getIndustryList", {
          params: { industryLevel: this.industryIndexList[e] },
        })
        .then((res) => {
          if (res.data.IndustryList) {
            this.industryList[e].children = [];
            res.data.IndustryList.forEach((item) => {
              this.industryList[e].children.push({
                text: item,
                id: item,
              });
            });
          }
        })
        .catch(() => {});
    },
    checkConfirm() {
      // console.log('City 选中列表', this.activeCitys, '左侧选择索引', this.activeProvinceIndex)
      // console.log('Industry 选中列表', this.activeIndustry, '左侧选择索引', this.activeIndustryIndex)
      this.searchData.currentPage = 1;
      this.alumnusList = [];
      this.initData();
      this.$refs.dropdownItemIndustry.toggle(false);
      this.$refs.dropdownItemCity.toggle(false);
    },
    /*  pageChange(e) {
       console.log('分页', e)
       this.initData()
     }, */
    // 懒加载
    onLoad() {
      this.searchData.currentPage = this.searchData.currentPage + 1;
      this.initData();
      this.loading = false;
      // 数据全部加载完成
      if (this.searchData.currentPage >= this.alumnusLastPage) {
        this.finished = true;
      }
    },
    goAlumniDetail(e) {
      // console.log(e)
      return this.$router.push({
        path: "/alumniDetailNew",
        query: { alumniId: e },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.alumniResourcesBox {
  position: relative;
  width: 100%;
  // .filter-box {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   z-index: 99;
  //   box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.1);
  //   border: 1px solid #000;

  //   .search-box {
  //     //padding: 5px 0;
  //   }

  //   // .filter-dropdown {
  //   //   position: fixed;
  //   //   //  top: 45px;
  //   //   //  left: 0;

  //   //   /deep/ .van-dropdown-menu__bar {
  //   //     box-shadow: none;
  //   //     border: 1px solid #888;
  //   //   }
  //   // }
  // }

  .filter-dropdown {
    position: fixed;
    top: 45px;
    left: 0;
    width: 100vw;
    z-index: 9999;

    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
      // border: 1px solid #888;
    }
  }

  .resources-list-box {
    padding: 2.666667vw;
    margin-top: 50px;
    //background-color: #e7c6c6;
  }
}

.van-sidebar-item--select::before {
  background-color: #00706e !important;
}

.van-tree-select__item--active {
  color: #00706e;
}

.van-button--danger {
  color: #fff;
  background-color: #00706e;
  border: 1px solid #00706e;
}
</style>



// WEBPACK FOOTER //
// src/components/alumniResources/AlumniResourcesNew.vue